import React from "react";
import { currencyFormatter } from "../../../../../_metronic/_helpers";
import { Card, CardBody } from "../../../../../_metronic/_partials/controls";

export function ConsolidationSumsWidget({
  consolidation_sums,
  period_type
}) {
  // Generate Period Time for Consolidation Sums
  function generatePeriodTime(param) {
    let periodTime = "";
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().toLocaleString("default", {
      month: "long"
    });

    if (param === "year") {
      periodTime = `${currentYear - 4} - ${currentYear}`;
    } else if (param === "month") {
      const startMonth = new Date().getMonth() - 4;
      const startYear = startMonth < 0 ? currentYear - 1 : currentYear;
      const formattedStartMonth = new Date(
        startYear,
        startMonth
      ).toLocaleString("id-ID", { month: "long" });
      periodTime = `${formattedStartMonth} - ${currentMonth}`;
    } else {
      periodTime = `${currentYear - 4} - ${currentYear}`;
    }

    return periodTime;
  }

  return (
    <div className="row">
      <div className="col row m-0 p-0">
        <div className="col-lg-4 col-md-6 col-sm-12">
          <Card>
            <CardBody>
              <h4 className="h4">Total Zakat</h4>
              <h6 className="h6">
                Konsolidasi {generatePeriodTime(period_type)}
              </h6>
              <div className="d-flex justify-content-end">
                <div className="h2 m-5">
                  {currencyFormatter(+consolidation_sums.total_zakat || 0)}
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <Card>
            <CardBody>
              <h4 className="h4">Total Infaq</h4>
              <h6 className="h6">
                Konsolidasi {generatePeriodTime(period_type)}
              </h6>
              <div className="d-flex justify-content-end">
                <div className="h2 m-5">
                  {currencyFormatter(+consolidation_sums.total_infaq || 0)}
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <Card>
            <CardBody>
              <h4 className="h4">Total Sedekah</h4>
              <h6 className="h6">
                Konsolidasi {generatePeriodTime(period_type)}
              </h6>
              <div className="d-flex justify-content-end">
                <div className="h2 m-5">
                  {currencyFormatter(+consolidation_sums.total_alms || 0)}
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
